<div class="booking-card">

  <app-bankid-section *ngIf="displayBankIdSection()"></app-bankid-section>

  <ng-container *ngIf="!displayBankIdSection()">
    <div class="summary-section__survey">
      <app-survey-v2></app-survey-v2>
    </div>
    <div *ngIf="errorMessage()" class="summary-section__error-message">
      <div [innerHTML]="errorMessage()"></div>
    </div>
    <div class="summary-section__submit-button">
      <app-ui-button
        (onClick)="sendBooking()"
        [color]="'green'"
        [compressed]="false"
        [expanded]="'inline'"
        [size]="'lg'"
        class="test-booking-book-btn"
      >
        Boka behandling
      </app-ui-button>
    </div>

    <div class="summary-section__terms">
      <p>
        Genom att genomföra bokningen godkänner du Vården.se
        <a [routerLink]="['/', 'info', 'villkor']" target="_blank"
        >Allmänna Villkor</a
        >
        för bokningstjänsten.
      </p>
    </div>
  </ng-container>
</div>
